<style scoped>
    .login_title {
        text-align: center;
        line-height: 50px;
        color: #fff;
        font-size: 26px;
        font-weight: 500;
        margin-bottom: 15px;
    }

    .login_box {
        position: absolute;
        left: 50%;
        width: 400px;
        margin-left: -200px;
        top: 50%;
        margin-top: -200px;
        height: 365px;
        background: #00000047;
        padding: 15px;
    }

    .user_box {
        background: #fff;
        height: 50px;
        position: relative;
        border-radius: 10px;
        margin-bottom: 30px;
    }

    .user_box img {
        margin-left: 12.5px;
        margin-top: 12.5px;
        width: 25px;
        height: 25px;
        /*vertical-align: */
    }

    .user_box input {
        width: calc(100% - 50px);
        border: none;
        height: 50px;
        padding: 0;
        position: absolute;
        top: 0;
        right: 0;
        background: none;
        outline: none;
        font-size: 16px;
    }

    .user_box input:active {
        border: none;
    }

    .get_yzm {
        position: absolute;
        right: 0;
        height: 50px;
        width: 150px;
        background: #20466d;
        color: #fff;
        border: none;
        outline: none;
        font-size: 16px;
        letter-spacing: 1.5px;
        font-family: '黑体';
        border-radius: 0 8px 8px 0;
    }

    .get_yzm:active {
        background: #19436d;
        font-size: 15px;
    }

    .login_btn {
        width: 100%;
        height: 50px;
        background: #20466d;
        color: #fff;
        border: none;
        outline: none;
        border-radius: 6px;
    }

    .login_btn:active {
        transform: scale(0.99);
        background: #19436d;
    }

    .no_user {
        color: #fff;
        font-size: 14px;
        margin-top: 15px;
    }

    .no_user span a {
        color: #6bcac1;
    }

    .forget_pwd {
        float: right;
        color: #fff;
    }

    .hide {
        opacity: 0;
        height: 0;
        overflow: hidden;
        width: 0;
    }

    #codeimage {
        width: 130px;
        height: 50px;
        position: absolute;
        right: 0;
        top: 0;
        margin: 0;
        border-radius: 0 10px 10px 0;
    }
    #app{
        background-color: #023d68;
        background-image: url('/static/bj.jpg');
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center;
    }
</style>
<template>
    <div id="app" >
        <div class="login_box">
            <div class="login_title">
                <span>排查系统登陆</span>
            </div>
            <div class="user_box">
                <img src="/static/user.png">
                <input type="text" v-model="login_info.username" class='username' placeholder="请输入手机号(小程序注册填写的手机号)" autocomplete='off'>
            </div>
            <div class="user_box">
                <img src="/static/password.png">
                <input type="password" v-model="login_info.password" class='password' placeholder="请输入密码(小程序注册填写的密码)" autocomplete='off'>
            </div>
            <div class="user_box">
                <img src="/static/yzm.png">
                <input type="text" v-model="login_info.yzm" class='yzm' placeholder="请输入验证码">
                <img id="codeimage" @click="create_yzm()" :src="yzm_img" />
            </div>
            <div class="btn_box">
                <button class='login_btn' @click="login()">登录</button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            var checkAge = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('年龄不能为空'));
                }
                setTimeout(() => {
                    if (!Number.isInteger(value)) {
                        callback(new Error('请输入数字值'));
                    } else {
                        if (value < 18) {
                            callback(new Error('必须年满18岁'));
                        } else {
                            callback();
                        }
                    }
                }, 1000);
            };
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.ruleForm.checkPass !== '') {
                        this.$refs.ruleForm.validateField('checkPass');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.ruleForm.pass) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                yzm_img: '/api/create_yzm',
                login_info: {
                    username: '',
                    password: '',
                    yzm: ''
                }
            };
        },
        created(){
            document.onkeydown = (e) => {
                let _key = window.event.keyCode;
                //!this.clickState是防止用户重复点击回车
                if (_key === 13&&!this.clickState) {
                    this.login();
                }
            };
        },
        //方法
        methods: {
            create_yzm() {
                this.yzm_img = '/api/create_yzm?' + Math.random()
            },
            login() {
                console.log(this.login_info)
                var login_info = this.login_info
                if (login_info.username.length == '') {
                    this.$message.error('登陆账号不能为空')
                    return false;
                }

                if (login_info.password.length == '') {
                    this.$message.error('密码不能为空')
                    return false;
                }

                if (login_info.yzm.length == '') {
                    this.$message.error('请输入验证码')
                    return false;
                }
                this.loading = this.$loading({
                    lock: true,
                    text: '正在登录...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.4)'
                });
                var _this = this;
                this.$axios.post(
                    '/api/user_login',
                    _this.login_info,
                ).then(function(res){
                    console.log(res)
                    var data = res.data;
                    _this.loading.close()
                    if(data.code=='200ok'){
                        _this.$message.success(data.msg)
                        window.localStorage.setItem('token',data.token)
                        setTimeout(function(){
                            _this.$router.push({path:'/'})
                        },500)
                    }else{
                        _this.$message.error(data.msg)
                    }
                }).catch(function (error) {
                    console.log(error);
                    _this.loading.close()
                    _this.$message.error('网络异常,请求失败')
                })
            },
        },
    }
</script>